import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { breakpoints } from '@/styles'
import { ValueText } from '@/features/Application/elements'
import { InformationTable, TableTitle } from '@/features/Application/elements/tables'
import useMediaQuery from '@/hooks/use-media-query'
import StatusComponent from './status-component'
import MobileSocialVerification from './mobile'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 18px;
`

const SocialVerification = ({ data = {}, isLocked, isLoading }) => {
  const { t } = useTranslation()
  const randomWords = '***** ******** *****'
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.tabletLandscape})`)
  const title = t('l.application.view.social_verification.label', 'Social Verification')
  const { rate, details = {} } = data
  const status = {
    poor: t('l.application.view.poor.label', 'Poor'),
    average: t('l.application.view.average.label', 'Average'),
    very_good: t('l.application.view.very_good.label', 'Very Good'),
    excellent: t('l.application.view.excellent.label', 'Excellent')
  }

  const statusText = status[rate]

  const columns = useMemo(
    () => [
      {
        Header: t('common.type', 'Type'),
        Cell: ({ row: { original } }) => {
          return (
            <ValueText type="small" isLocked={isLocked}>
              {isLocked ? randomWords : original?.[0]?.type ?? '-'}
            </ValueText>
          )
        }
      },
      {
        Header: t('common.status', 'Status'),
        Cell: ({ row: { original } }) => (
          <StatusComponent
            status={original?.[0]?.status?.toLowerCase().replace(' ', '_')}
            isLocked={isLocked}
          />
        )
      },
      {
        id: 'empty',
        Header: ''
      }
    ],
    [isLocked, isLoading]
  )

  const tableData = [details]

  return (
    <Wrapper>
      <TableTitle
        title={title}
        showStatus={true}
        statusType={rate}
        statusText={statusText}
        isLocked={isLocked}
        isLoading={isLoading}
      />
      <InformationTable
        data={tableData}
        columns={columns}
        hideHeader={isMobile}
        showBorder
        isLoading={isLoading}
      />
    </Wrapper>
  )
}

export { MobileSocialVerification }
export default SocialVerification
